import * as React from 'react';
import {FunctionComponent} from 'react';
import {Feedback} from '../../../Components/Feedback';
import {EventCalendar} from '../../Calendar/EventCalendar';
import {YourCrews} from '.././Components/YourCrews';
import {PresenterProps, withPresenter} from '../../../../Support/with_presenter';
import {CrewsIndexCalendarPresenter} from './CrewsIndexCalendarPresenter';
import {NetworkRequestStatusView} from '../../../Components/Utils/NetworkRequestStatusView';
import {Crew, FullCrew} from '../../../../Models/Crew';
import {observer} from 'mobx-react';
import {CrewInvites} from '../../../Components/Crew/CrewInvites';
import {Loader} from '../../../Components/Utils/Loader';
import {UpcomingEvents} from '../../../Components/Crew/UpcomingEvents';
import {CrewICal} from '../../../Components/Crew/CrewICal';
import {Confirm} from '.././Components/Confirm';
import {About} from '.././Components/About';
import {ErrorPlaceholder} from '../../../Components/Utils/ErrorPlaceholder';
import {Sidebar} from '../Components/Sidebar';

interface OwnProps {}

const CrewsIndexComponent: FunctionComponent<OwnProps & PresenterProps<CrewsIndexCalendarPresenter>> = observer(
    ({presenter}) => {
        const meResult = presenter.me;
        const crewsResult = presenter.crews;
        return (
            <div className="container">
                <div className="row">
                    <div className="col-12">
                        <h1>My Crews</h1>
                    </div>
                </div>
                <div className="row">
                    <div className="col-12 mb-3 col-lg-9">
                        <NetworkRequestStatusView
                            result={meResult}
                            loader={() => <Loader />}
                            error={() => <ErrorPlaceholder large />}
                            component={(me) => {
                                if (!me.isConfirmed) {
                                    return (
                                        <>
                                            <Confirm className="mb-3" />
                                            <About />
                                        </>
                                    );
                                }
                                return (
                                    <NetworkRequestStatusView<FullCrew[]>
                                        result={crewsResult}
                                        loader={() => <Loader />}
                                        error={() => <ErrorPlaceholder large />}
                                        component={(data) => <EventCalendar key="success" crews={data} />}
                                    />
                                );
                            }}
                        />
                    </div>
                    <div className="col-12 col-lg-3">
                        <Sidebar />
                        <UpcomingEvents className="mb-3" />
                        <CrewInvites className="mb-3" />
                        <NetworkRequestStatusView
                            result={meResult}
                            loader={() => null}
                            error={() => null}
                            component={(me) => {
                                if (!me.isConfirmed) {
                                    return null;
                                }
                                return (
                                    <NetworkRequestStatusView<Crew[]>
                                        result={presenter.crews}
                                        loader={() => <YourCrews className="skeleton mb-3" crews={[]} />}
                                        error={() => <YourCrews className="skeleton mb-3" crews={[]} />}
                                        component={(data) => <YourCrews className="mb-3" crews={data} />}
                                    />
                                );
                            }}
                        />
                        <CrewICal className="mb-3" />
                        <Feedback />
                    </div>
                </div>
            </div>
        );
    },
);

export const CrewsIndexCalendar = withPresenter<CrewsIndexCalendarPresenter, OwnProps>(
    (props, component) => new CrewsIndexCalendarPresenter(component.network.me, component.network.crews),
    CrewsIndexComponent,
);
